import { Pipe, PipeTransform } from '@angular/core';


// #region PIPE TRADUCTION
@Pipe({
  name: 'gethour'
})
export class GetHourReservationStagiairePipe implements PipeTransform {

  transform(date: string): string {
    if (date === undefined) {
      return 'no date';
    } else {
      return date.split(' ')[1].substring(0, 5);
    }
  }
}

@Pipe({
    name: 'getdate'
  })
  export class GetDateReservationStagiairePipe implements PipeTransform {

    transform(date: string): string {
      if (date === undefined) {
        return 'no date';
      } else {
        return date.split(' ')[0];
      }
    }
  }
